import { Component, DestroyRef, OnInit } from '@angular/core';
import { DashboardChartsComponent } from '../../pages/charts/charts.component';
import { DashboardFooterComponent } from '../dashboard-footer/dashboard-footer.component';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { DashboardcardsComponent } from '../dashboard-cards/dashboard-cards.component';
import { LanguageService } from '@app/core/language/language.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-dashboard-details',
  templateUrl: './dashboard-details.component.html',
  styleUrls: ['./dashboard-details.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS, DashboardcardsComponent, DashboardChartsComponent, DashboardFooterComponent]
})
export class DashboardDetailsComponent implements OnInit {
  carts: Array<any> = [];
  constructor(private languageService: LanguageService, private destroyRef: DestroyRef) {
    this.carts = [
      { label: 'carts.districts', number: 45, icon: 'beach-house', to: 'reports/district-report' },
      { label: 'carts.weight', number: 45, icon: 'weight', to: 'reports/weights-report' },
      { label: 'carts.units', number: 45, icon: 'delivery-truck', to: 'reports/units-report' },
      { label: 'carts.contractors', number: 45, icon: 'businessman', to: 'reports/contractors-report' },
      { label: 'carts.waste_type', number: 45, icon: 'recycle-bin', to: 'reports/waste-type-report' }
    ];
  }

  ngOnInit() {}

  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}
